<header>

  <div class="alert-bar" *ngIf="showAlert > 0" style="display: flex; align-items: center;">
    <a *ngIf="showAlert == 1" routerLink="/my-info/payment-method" style="flex: 1; text-align: center;">
      Your subscription payment is overdue. Please click here to update your payment method. If payment is not completed within 30 days, your subscription will be paused.
    </a>
    <a *ngIf="showAlert == 2" routerLink="/my-info/payment-method" style="flex: 1; text-align: center;">
      Your subscription payment is past due over 30 days. Your account is now paused until payment is made. Please check your payment method on file.
    </a>
    <span *ngIf="showAlert == 3" style="flex: 1; text-align: center;">
      You are using test data, no transactions will be processed. No notifications will be sent.
    </span>
    <button *ngIf="showAlert < 3" type="button" class="close-btn" (click)="closeAlert()" aria-label="Close alert"
            [disabled]="showAlert === 2">×
    </button>
  </div>

  <app-common-header
    [userProfile]="userProfile"
    [mainMenu]="mainMenu"
    [notifications]="notifications"
    [showAlert]="showAlert"
    (logoutClicked)="logout()"
    (showSideMenu)="toggleSideMenu()"
  ></app-common-header>
</header>

<main class="main__wrapper" [class.main__wrapper--animate]="showSidebar" [ngClass]="{main__content_alert: showAlert}">
  <section class="main__sidebar" *ngIf="sidebar">
    <!-- <common-sidebar
      [sidebar]="sidebar"
      [showSidebar]="showSidebar"
    ></common-sidebar> -->
  </section>

  <section class="main__content">

    <app-common-right-sidebar
      [mainMenu]="mainMenu"
      [showSideMenu]="showSideMenu"
    ></app-common-right-sidebar>

    <router-outlet></router-outlet>
  </section>
</main>

<app-loader [showAppLoader]="showAppLoader"></app-loader>
